import { useStore } from '@/store';
import { presets } from '@utils/dependencyLoader/loader/preset-loader';
import useDepLoader from '@composables/useDepLoader';
export const handleAiPageConfig = (externals) => {
    const dependencies = new Set();
    externals.forEach((dependency) => {
        if (dependency.startsWith('@wuji-go')) {
            return;
        }
        if (presets.includes(dependency)) {
            return;
        }
        dependencies.add(dependency);
    });
    return dependencies;
};
// AI页面统一用这个字段作为依赖
const AI_PAGE_ID = 'wuji-ai-page_deps';
const useAiDepLoader = () => {
    const { updateDependency, loadDependencies } = useDepLoader();
    const loadAIPageDependency = (runtime = false) => {
        const store = useStore();
        const dependency = runtime ? store.state.runtime.project.dependency : store.state.project.projectInfo.dependency;
        const externals = dependency?.pages?.[AI_PAGE_ID] || [];
        loadDependencies(handleAiPageConfig(externals));
    };
    const updateAIPageDependency = (externals) => {
        const dependencies = handleAiPageConfig(externals);
        return updateDependency(dependencies, AI_PAGE_ID);
    };
    return {
        loadAIPageDependency,
        updateAIPageDependency,
    };
};
export default useAiDepLoader;
